module.exports = __webpack_public_path__ + "media/imessage_receive.c13ce4f3.mp3";